import { render, staticRenderFns } from "./GroupRoleEdit.vue?vue&type=template&id=77a00474"
import script from "./GroupRoleEdit.vue?vue&type=script&lang=js"
export * from "./GroupRoleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports